import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import UsageStats from './components/UsageStats';
import ProPlanTeaser from './components/ProPlanTeaser';
import CreateQuiz from './pages/CreateQuiz';
import Profile from './pages/Profile';
import About from './pages/About';
import EditQuiz from './pages/EditQuiz';
import PlayQuiz from './pages/PlayQuiz';
import HostQuiz from './pages/PlayQuiz';
import QuizStatistics from './pages/QuizStatistics';
import QuizResults from './pages/QuizResults';
import StripeReturn from './pages/StripeReturn';
import LogoutSuccess from './pages/LogoutSuccess';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './pages/HomePage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/create-quiz" element={<CreateQuiz />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/about" element={<About />} />
          <Route path="/edit-quiz/:quizId" element={<EditQuiz />} />
          <Route path="/play-quiz/:quizId" element={<PlayQuiz />} />
          <Route path="/host-quiz/:quizId" element={<HostQuiz />} />
          <Route path="/quiz-statistics" element={<QuizStatistics />} />
          <Route path="/quiz-results/:quizId" element={<QuizResults />} />
          <Route path="/stripe-return" element={<StripeReturn />} />
          <Route path="/logout-success" element={<LogoutSuccess />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;